<template>
  <div class="render">
    <div class="vacate">
      <el-form-item
        :label-width="itemRender.width"
        :label="itemRender.label"
        :required="itemRender.required ? true : false"
      >
        <div class="vacate-item">
          <span>出差事由</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>日程</span>
          <!-- <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input> -->
        </div>
        <div class="vacate-item">
          <span>交通工具</span>
          <el-input v-model="itemRender.value" placeholder="必填"></el-input>
        </div>
        <div class="vacate-item">
          <span>单程往返</span>
          <el-input v-model="itemRender.value" placeholder="必填"></el-input>
        </div>
        <div class="vacate-item">
          <span>出发城市</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入城市(必填)"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>目的城市</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入城市(必填)"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>开始时间</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入时间(必填)"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>结束时间</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入时间(必填)"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>时长</span>
          <el-input
            v-model="itemRender.value"
            placeholder="自动计算,无需填写(必填)"
          ></el-input>
        </div>
        <div class="vacate-item vacate-item2">
          <i class="el-icon-plus"></i> 增加行程
        </div>
        <div class="vacate-item" v-if="itemRender.timeDay">
          <span>出差天数</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>出差备注</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入具体的出差备注"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>出行人(同行人)</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.external">
          <span>外部人员</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入(多人用,隔开)"
          ></el-input>
        </div>
      </el-form-item>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemRender: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
::v-deep .el-radio-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .el-radio {
    margin-bottom: 12px;
  }
}
.vacate {
  .vacate-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    padding: 0 0 8px;
    border-bottom: 1px solid #dfe2e8;
    ::v-deep .el-input__inner {
      border: 0;
    }
    span {
      width: 100px;
    }
  }
  .vacate-item2 {
    background-color: #f7f9ff;
    display: block;
    text-align: center;
    color: #0089ff;
  }
}
.el-form-item {
  position: relative;
  .phone {
    position: absolute;
    right: 10px;
    top: 0px;
  }
  .phoneNumber {
    display: flex;
    align-items: center;
    border: 1px solid #dfe2e8;
    padding: 0 8px;
    ::v-deep .el-input__inner {
      border: 0;
    }
    span {
      padding-right: 8px;
      border-right: 1px solid #dfe2e8;
    }
  }
  .enclosure {
    display: flex;
    align-items: center;
    color: #999999;
    i {
      color: #5794f6;
      font-size: 18px;
      font-weight: bold;
      margin-right: 8px;
    }
  }
}
.money {
  .div {
    margin-top: 12px;
  }
}
</style>
